import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class SaleorderTypeDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "States id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "States Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({message:"Sale Order Type id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  saleorderTypeId: number;
  @ApiProperty()
  @MaxLength(15, { message: "Sale Order Type allows maximum 15 characters" })
  @IsNotEmpty()
  // @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Variant name should be only alpha numeric" })
  // @IsNotBlank('StatesName', { message: "States Name is not to be a white spaces" })
  saleOrderTypeName: string;
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

